<template>
  <div class="container-custom">
    <!-- breadscrumbs -->
    <div class="breadscrumbs">
      <a class="breadscrumbs-item active">Career</a>
    </div>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>Career</h2>
      <v-spacer></v-spacer>
      <button class="btn" @click="toCareerPageEdit">
        <v-icon class="mr-2">edit</v-icon>
        <span>編輯</span>
      </button>
    </div>

    <!-- block 2 -->
    <div class="block" style="margin-bottom: 30px;" v-if="career">
      <PageMenu :sections="sections">
        <component :is="sectionView" style="min-height: 800px;" :career="career"></component>
      </PageMenu>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import PageMenu from '@/components/PageMenu.vue';
import MainMessaging from '@/views/B-5__CareerPage/c/B-5-1__Career_MainMessaging.vue';
import CompanyCulture from '@/views/B-5__CareerPage/c/B-5-2__Career_CompanyCulture.vue';
import DepartmentTeams from '@/views/B-5__CareerPage/c/B-5-3__Career_Departments&Teams.vue';
import JobInformation from '@/views/B-5__CareerPage/c/B-5-4__Career_JobInformation.vue';
import VideoRotate from '@/views/B-5__CareerPage/c/B-5-5__Career_VideoRotate.vue';

export default {
  components: {
    PageMenu,
    MainMessaging,
    CompanyCulture,
    DepartmentTeams,
    JobInformation,
    VideoRotate,
  },
  data: () => ({
    sections: [
      { name: 'Main Messaging', component: 'MainMessaging' },
      { name: 'Company Culture', component: 'CompanyCulture' },
      { name: 'Departments & Teams', component: 'DepartmentTeams' },
      { name: 'Job Information', component: 'JobInformation' },
      { name: 'Video Rotate', component: 'VideoRotate' },
    ],
  }),
  computed: {
    ...mapState('career', ['career']),
    sectionIndex() {
      const vm = this;
      return vm.$route.query.section || 0;
    },
    sectionView() {
      const vm = this;
      return vm.sections[vm.sectionIndex].component;
    },
  },
  async created() {
    await this.getCareer();
  },
  methods: {
    ...mapActions('career', {
      getCareer: 'find',
      clear: 'clear',
    }),
    toCareerPageEdit() {
      this.$router.push({
        name: 'CareerPageEdit',
        query: {
          section: this.$route.query.section,
        },
      });
    },
  },
};
</script>

<style></style>
